{
  "name": "@bmpr/cli",
  "version": "0.0.20",
  "description": "CLI for bmpr - AI memory system for coding projects",
  "main": "dist/index.js",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "type": "module",
  "bin": {
    "bmpr": "dist/index.js"
  },
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "types": "./dist/index.d.ts"
    }
  },
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "lint": "echo 'linting cli'"
  },
  "files": [
    "dist"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/oheriko/bumper.git",
    "directory": "packages/cli"
  },
  "homepage": "https://github.com/oheriko/bumper#readme",
  "bugs": {
    "url": "https://github.com/oheriko/bumper/issues"
  },
  "keywords": [
    "ai",
    "memory",
    "coding",
    "project",
    "context",
    "mcp",
    "claude"
  ],
  "author": "Erik Wright",
  "license": "MIT",
  "dependencies": {
    "@bmpr/templates": "workspace:*",
    "@clack/prompts": "latest",
    "kleur": "latest"
  },
  "devDependencies": {
    "@types/bun": "latest",
    "@types/markdown-it": "latest",
    "@types/node": "latest"
  },
  "peerDependencies": {
    "typescript": "^5"
  },
  "engines": {
    "node": ">=18"
  }
}
